export const UPCOMING_EVENT_COUNTDOWN_DEFAULT_BACKGROUND_IMAGE =
  'assets/images/svg/event_ticketing_bg.svg';

export const UPCOMING_EVENT_COUNTDOWN_BACKGROUND_COLOR_TOKENS = {
  ACCENT: '#5A0922',
  GRADIENT_OVERLAY: '#000000'
} as const;

export const UPCOMING_EVENT_COUNTDOWN_BACKGROUND_FALLBACK_COLORS = {
  accent: '#002740',
  gradientOverlay: '#191a1c'
} as const;

export const UPCOMING_EVENT_COUNTDOWN_CONSTANTS = {
  labels: {
    heading: 'Upcoming Event In',
    eventStartedHeading: 'Event Started',
    days: 'Days',
    hours: 'Hrs',
    minutes: 'Min',
    seconds: 'Sec',
    moreInfo: 'More Info'
  },
  lessonLabels: {
    heading: 'Upcoming Lesson In',
    eventStartedHeading: 'Lesson Started'
  },
  countdown: {
    intervalMs: 1000,
    padLength: 2,
    padChar: '0',
    separator: ':',
    postEventGracePeriodMs: 3_600_000
  }
} as const;
